export default class GTMEventService {
    static triggerEvent(eventName) {
        window.dataLayer = window.dataLayer || [];
        let event = {'event': eventName};
        window.dataLayer.push(event);
    }
}
